import { Color } from 'ngx-color';
import { HSLA }  from 'ngx-color/helpers/color.interfaces';

// ENUMS #############################################################
export enum ColorPickerTypeEnum {
	HUE = 'hue',
	PREVIEW = 'preview',
	SLIDER = 'slider',
	SWATCHES = 'swatches'
}

// TYPES #############################################################
export type ColorConfigType =
	IColorHueConfig
	| IColorPreviewConfig
	| IColorSliderConfig
	| IColorSwatchesConfig;

// INTERFACES ########################################################
export interface ColorPickerEvent {
	type: ColorPickerTypeEnum;
	selectedColor: Color;
}

export interface ISwatchItem {
	id: number;
	color: Color;
	hsla: HSLA;
	isActive: boolean;
	offset: number;
}

export interface IColorObject {
	red: number;
	green: number;
	blue: number;
	hue: number;
	sat: number;
	hex: string;
	lightness: number;
	whiteness: number;
	blackness: number;
	cyan: number;
	magenta: number;
	yellow: number;
	black: number;
	ncol: string;
	opacity: number;
	valid: boolean;
}

// tslint:disable-next-line:no-empty-interface
export interface IColorBaseConfig {}

export interface IColorHueConfig extends IColorBaseConfig {
	type: ColorPickerTypeEnum.HUE;
}

export interface IColorPreviewConfig extends IColorBaseConfig {
	type: ColorPickerTypeEnum.PREVIEW;
}

export interface IColorSliderConfig extends IColorBaseConfig {
	type: ColorPickerTypeEnum.SLIDER;
	/**
	 * amount of color steps inside the defined allowed color range
	 */
	swatchCount: number;
	/**
	 * percent number 0-100
	 */
	swatchStartLightness: number;
	/**
	 * percent number 0-100
	 */
	swatchEndLightness: number;
}

export interface IColorSwatchesConfig extends IColorBaseConfig {
	type: ColorPickerTypeEnum.SWATCHES;
	/**
	 * first array dimension for color group, second array dimension for group colors as hex
	 */
	presetColors: string[][];
}

export class ColorPickerConfig {
	public preview?: IColorPreviewConfig = undefined;
	public swatches?: IColorSwatchesConfig = undefined;
	public slider?: IColorSliderConfig = undefined;
}

